import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { getImage, GatsbyImage } from "gatsby-plugin-image";
import Link from "../../link/link";

const CopyScapeButton = ({ url }) => {
  const imageData = useStaticQuery(graphql`
    query {
      data: file(relativePath: { eq: "copyscape.tiff" }) {
        childImageSharp {
          gatsbyImageData(placeholder: BLURRED, width: 250)
        }
      }
    }
  `);
  return (
    <Link url={url}>
      <GatsbyImage image={getImage(imageData.data)} alt="Banner Ad" />
    </Link>
  );
};

export default CopyScapeButton;
